import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const PRICE = "$59.95";

// "20% complete" continuation invitation (Glimpse Portrait + dashboard).
export const GlimpseJourneyCard = ({ journey, variant = "portrait" }) => {
  const navigate = useNavigate();
  if (!journey || journey.stage === "complete") return null;
  const dash = variant === "dashboard";
  const pct = journey.percent;
  const primary = {
    invite: [`Complete My Authority Portrait — ${PRICE}`, "/payment"],
    ready_to_start: ["Continue My Authority Portrait", "/consent"],
    in_progress: ["Continue My Authority Portrait", "/assessment"],
  }[journey.stage];
  return (
    <div className="cg-card p-7 sm:p-8 border-brass/40" data-testid={`glimpse-journey-${variant}`}>
      {dash ? (
        <>
          <p className="cg-eyebrow mb-2" data-testid="journey-percent">Your Authority Journey — {pct}% Complete</p>
          <div className="h-1.5 rounded-full bg-[#222634] overflow-hidden mb-4"><div className="h-full bg-brass" style={{ width: `${pct}%` }} /></div>
          <p className="text-[#B9BDC7]">You've already answered {journey.answered} of {journey.total} statements.</p>
          <p className="text-sm text-[#9CA3AF] mt-1">Your responses are saved, and your Authority Glimpse Portrait is ready to revisit.</p>
          {journey.stage === "invite" && <p className="text-sm text-[#9CA3AF] mt-1">Ready to continue?</p>}
        </>
      ) : (
        <>
          <p className="font-serif text-5xl text-brass leading-none" data-testid="journey-percent">{pct}%</p>
          <h2 className="font-serif text-3xl text-[#F3F4F6] mt-3">You've Already Completed 20% of Your Authority Portrait!</h2>
          <p className="text-[#B9BDC7] mt-3">You've taken the first step toward understanding where your authority lies.</p>
          <p className="text-[#B9BDC7] mt-2">You've completed {journey.answered} of the {journey.total} statements in the full Human Authority Assessment.</p>
          <p className="text-[#B9BDC7] mt-2">Why not continue your journey?</p>
          <p className="text-sm text-[#9CA3AF] mt-2">Your responses are already saved. Complete the remaining {journey.total - journey.answered} statements to receive your comprehensive Authority Portrait.</p>
        </>
      )}
      <div className="mt-6 flex flex-wrap gap-3">
        <button data-testid="journey-continue-button" onClick={() => navigate(primary[1])}
          className="inline-flex items-center gap-2 bg-brass text-obsidian font-medium px-6 py-3 rounded-full cg-scale-btn hover:bg-amber2">
          {primary[0]} <ArrowRight className="w-4 h-4" />
        </button>
        {dash ? (
          <button data-testid="journey-view-glimpse" onClick={() => navigate("/glimpse/portrait")}
            className="px-6 py-3 rounded-full border border-[var(--cg-border)] text-[#E8EAEE] hover:border-brass transition-colors">View My Authority Glimpse</button>
        ) : (
          <button data-testid="journey-later" onClick={() => navigate("/dashboard")}
            className="px-6 py-3 rounded-full border border-[var(--cg-border)] text-[#E8EAEE] hover:border-brass transition-colors">I'll Come Back Later</button>
        )}
      </div>
    </div>
  );
};
